import { Component } from "@angular/core";
import { NavParams, ViewController, Loading, LoadingController } from "ionic-angular";
import { ManualPointService } from "../../../services/manual-point.service";
import { MobileDataService } from "../../../services/mobile-data.service";
import { Storage } from "@ionic/storage";
import * as jsPDF from "jspdf";
import { AlertController } from 'ionic-angular';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "email-details",
    templateUrl: "email-details.html",
    providers: [TranslateService]
})
export class EmailDetailsComponent {

    public pdfData: string;
    public pdfPath: string;
    public access_token: string;
    public toAdd: string = "";
    public ccAdd: string = "";
    public pdfUrl: string;
    public htmlElementSelector: string;
    public reportFileName: string;

    public spinner = {
        content: 'Sending email...',
        spinner: 'bubbles'
    }
    public sendEmailSpinner: Loading;
    constructor(
        private navParams: NavParams,
        private viewCtrl: ViewController,
        private manualPointService: ManualPointService,
        private mobileDataService: MobileDataService,
        private storage: Storage,
        private loadingCtrl: LoadingController,
        private alertCtrl: AlertController,
        public translate: TranslateService
    ) {

        //  this.pdfData = this.navParams.get("pdfData");
        this.pdfPath = this.navParams.get("filePath");
        this.access_token = sessionStorage.getItem('access_token');
        this.pdfUrl = this.navParams.get("pdfUrl");
        this.htmlElementSelector = this.navParams.get("htmlElementSelector");
        this.reportFileName = this.navParams.get("reportFileName");
    }

    cancel() {
        this.viewCtrl.dismiss();
    }

    validateEmail(email: string) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }

    send() {
        this.sendEmailSpinner = this.loadingCtrl.create(this.spinner);
        this.sendEmailSpinner.present();
        let pdf = new jsPDF('18', 'px', 'a4');
        let self = this;
        var blob = pdf.output('datauristring');
        let payload = {
            imagedata: blob.replace('data:application/pdf;base64,', ''),
            entitytype: 'MailReports',
            imagetype: 'pdf',
            //  imagedata: JSON.stringify(this.pdfData)
        }
        this.storage.get("access_token").then((token) => {
            token = this.access_token;
            let emailPayload = {
                PDFPath: this.pdfPath,
                Container: "mailreports",
                ReportName: "Chiller_Snapshot",
                To: self.toAdd,
                Cc: self.ccAdd
            }


            this.manualPointService.sendEmail(token, emailPayload)
                .subscribe((res) => {
                    this.viewCtrl.dismiss();
                    this.sendEmailSpinner.dismiss();
                }, (err) => {
                    this.viewCtrl.dismiss();
                    this.sendEmailSpinner.dismiss();
                });

        });

        this.sendnotification();

    }
    
    sendNew() {
        this.sendEmailSpinner = this.loadingCtrl.create(this.spinner);
        this.sendEmailSpinner.present();
        let self = this;
        let body = {
            "url": this.pdfUrl,
            "htmlElementSelector": this.htmlElementSelector,
            "reportFileName": this.reportFileName,
            "Type": "Email"
        }
        this.mobileDataService.GenerateLogReports(this.access_token, body)
            .subscribe((data) => {
                if (data && data.length > 0) {
                    let filePath = data[0].filePath.split('Download\\');
                    var fileName = filePath[1];
                    let emailPayload = {
                        PDFPath: fileName,
                        Container: "mailreports",
                        ReportName: "Chiller_Snapshot",
                        To: self.toAdd,
                        Cc: self.ccAdd
                    }
                    this.manualPointService.sendEmailNew(this.access_token, emailPayload)
                        .subscribe((res) => {
                            this.viewCtrl.dismiss();
                        }, (err) => {
                            this.viewCtrl.dismiss();
                        });
                }
                this.sendEmailSpinner.dismiss();
            }, (error) => this.sendEmailSpinner.dismiss());
    }

    sendnotification() {
        let alert = this.alertCtrl.create({
            subTitle: this.translate.instant('Emailsentsuccessfully'),
            buttons: [this.translate.instant('ok')],
            enableBackdropDismiss: false
        });
        alert.present();
    }

}


// WEBPACK FOOTER //
// ./src/components/reports/email-details/email-details.component.ts